<template>
  <div id="app">
  <b-navbar toggleable="lg" class="navbar bg-body border-bottom border-body">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand to="/"><img src="../assets/images/UMAI.svg" style="fill: '#17a2b8'" width="70" height="30" alt="альтернативный текст"></b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav>
        <b-nav-item-dropdown text="Платежи" v-if="section('payments')" >
          <template v-slot:button-content>
            <i class="bi bi-search" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/payments" replace v-if="can('payments')">Транзакции</b-dropdown-item>
          <b-dropdown-item to="/paymentlogs" v-if="can('paymentlogs')">Логи платежей</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Отчеты" v-if="section('reports')">
          <template v-slot:button-content>
            <i class="bi bi-graph-up" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/supplierpayments" v-if="can('reports.suppliers')">Поставщики</b-dropdown-item>
          <b-dropdown-item to="/dealerpayments" v-if="can('reports.dealers')">Дилеры</b-dropdown-item>
          <b-dropdown-item to="/terminalpayments" v-if="can('reports.terminals')">Терминалы</b-dropdown-item>
          <b-dropdown-item to="/dealercash" v-if="can('reports.dealercash')">Сумма к инкассации</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Терминалы" v-if="section('terminals')">
          <template v-slot:button-content>
            <i class="bi bi-terminal" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/terminalstatus" replace v-if="can('terminals.status')">Состояние терминалов</b-dropdown-item>
          <b-dropdown-item to="/encashmentlist" v-if="can('terminals.encashmentlist')">Список к инкассации</b-dropdown-item>
          <b-dropdown-item to="/terminalcash" v-if="can('terminals.cash')">Деньги в терминалах</b-dropdown-item>
          <b-dropdown-item to="/encashments" v-if="can('terminals.encashments')">История инкассаций</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Файлы" v-if="section('files')">
          <template v-slot:button-content>
            <i class="bi bi-file-earmark-spreadsheet" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/reestrs" v-if="can('files.reestrs')">Реестры и акты</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Справочники" v-if="section('catalogs')">
          <template v-slot:button-content>
            <i class="bi bi-list-ul" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/banks" v-if="can('catalog.banks')">Контрагенты</b-dropdown-item>
          <b-dropdown-item to="/suppliers" v-if="can('catalog.suppliers')">Поставщики</b-dropdown-item>
          <b-dropdown-item to="/servicegroups" v-if="can('catalog.servicegroups')">Категории сервисов</b-dropdown-item>
          <b-dropdown-item to="/services" v-if="can('catalog.services')">Сервисы</b-dropdown-item>
          <b-dropdown-item to="/dealerservices" v-if="can('catalog.dealerservices')">Сервисы дилера</b-dropdown-item>
          <b-dropdown-item to="/dealers" v-if="can('catalog.dealers')">Дилеры</b-dropdown-item>
          <b-dropdown-item to="/terminals" v-if="can('catalog.terminals')">Терминалы</b-dropdown-item>
          <b-dropdown-item to="/users" v-if="can('users')">Пользователи</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Анкеты" v-if="section('profiles')">
          <template v-slot:button-content>
            <i class="bi bi-file-earmark-person-fill" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/profiles" v-if="can('profiles.mpa')">Клиенты МПА</b-dropdown-item>
          <b-dropdown-item to="/wallets" v-if="can('profiles.umai')">Кошельки UMAI</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown text="Настройки" v-if="section('setup')">
          <template v-slot:button-content>
            <i class="bi bi-gear" style="font-size: 14px"></i>
          </template>
          <b-dropdown-item to="/roleconfig" v-if="can('setup.roles')">Настройка ролей</b-dropdown-item>
          <b-dropdown-item to="/vpn" v-if="can('setup.vpn')">OpenVPN</b-dropdown-item>
          <b-dropdown-item to="/yandex" v-if="can('setup.yandex')">Яндекс Такси</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ms-auto">
        <li class="nav-item" v-if="balanceOn && balance !== null">
          <span class="nav-link" data-test="balance" title="Баланс" :style="{ color: balance > 0 ? 'green' : 'red' }">
            <em>{{ balanceText }}</em>
          </span>
        </li>
        <b-nav-item to="/login" v-if="!loggedIn">Вход</b-nav-item>
        <b-nav-item-dropdown right v-if="loggedIn">
          <template v-slot:button-content>
            <em>{{Username}}</em>
          </template>
          <b-dropdown-item to="/profile">Профиль</b-dropdown-item>
          <b-dropdown-item @click.stop="logout" to="/">Выход</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

</div>
</template>
<script>
import { mapStores } from 'pinia';
import { useAuthStore } from '@/lib/store/authentication.module';
import { useAlertStore } from '@/lib/store/alert.module';
import { useUsersStore } from '@/lib/store/users.module';
import { formatMoney } from '@/lib/format';

// Баланс в шапке обновляется раз в 5 минут, как в старом kiosk
const BALANCE_REFRESH_MS = 5 * 60 * 1000;

// Раздел меню → права его пунктов (ключи каталога server/lib/permissions.js,
// docs/Сервер/Права ролей.md). Баланс в шапке — отдельно, право balance
const SECTIONS = {
  payments:  ['payments', 'paymentlogs'],
  reports:   ['reports.suppliers', 'reports.dealers', 'reports.terminals', 'reports.dealercash'],
  terminals: ['terminals.status', 'terminals.encashmentlist', 'terminals.cash', 'terminals.encashments'],
  files:     ['files.reestrs'],
  catalogs:  ['catalog.banks', 'catalog.suppliers', 'catalog.servicegroups', 'catalog.services',
              'catalog.dealerservices', 'catalog.dealers', 'catalog.terminals', 'users'],
  profiles:  ['profiles.mpa', 'profiles.umai'],
  setup:     ['setup.roles', 'setup.vpn', 'setup.yandex'],
};

export default {
  name: 'SiteNav',
  sections: SECTIONS,
  data: () =>  ({
    // Баланс своего партнёра (GET /users/me/balance). null — нет баланса
    // (не дилер), ещё не загружен или запрос не прошёл: тогда виджета нет
    balance: null,
    balanceTimer: null,
  }),
  watch: {
    // Права приходят после монтирования (fetchUserConfig), поэтому баланс
    // запрашивается, когда право появилось, а не в mounted
    balanceOn: {
      immediate: true,
      handler(on) {
        clearInterval(this.balanceTimer);
        this.balanceTimer = null;
        this.balance = null;
        if (!on) return;
        this.loadBalance();
        this.balanceTimer = setInterval(this.loadBalance, BALANCE_REFRESH_MS);
      },
    },
  },
  computed: {
    ...mapStores(useAuthStore, useAlertStore, useUsersStore),
    balanceOn() {
      return Boolean(this.loggedIn) && this.can('balance');
    },
    balanceText() {
      return formatMoney(this.balance);
    },
    user() {
      return this.authenticationStore.user;
    },
    Username() {
      return this.authenticationStore.user?.name || 'Вход';
    },
    loggedIn() {
      return this.authenticationStore.user ? this.authenticationStore.status?.loggedIn : false;
    }
  },
  methods: {
    can(key) {
      return this.usersStore.can(key);
    },
    // Раздел виден, если есть хоть один его пункт
    section(name) {
      return this.usersStore.canAny(...SECTIONS[name]);
    },
    logout() {
      this.authenticationStore.logout();
    },
    async loadBalance() {
      try {
        this.balance = await this.usersStore.getMyBalance();
      } catch {
        // Сообщение об ошибке уже показал API.module
        this.balance = null;
      }
    },
  },
  mounted () {
    if (this.loggedIn) this.usersStore.fetchUserConfig();
  },
  beforeUnmount () {
    clearInterval(this.balanceTimer);
  }
}
</script>
<style>

.navbar {
  font-size: 13px;
}
.input {
  margin: 6px;
}
</style>
